import React, { ChangeEvent } from 'react'
import styles from './Select.module.scss'

interface Option {
  key: string
  label: string
}

interface Props {
  label: string
  options: Option[]
  selectedKey?: string|string[]
  onSelect?: (key: string) => void
}

export default function Select({ label, options, selectedKey, onSelect }: Props) {
  function handleSelect(e: ChangeEvent<HTMLSelectElement>) {
    if (onSelect) {
      onSelect(e.target.value)
    }
  }

  return (
    <div className={styles.selectWrapper}>
      <label htmlFor={label}>{label}</label>
      <select id={label} onChange={handleSelect} value={selectedKey}>
        {options.map(({ key, label }) => (
          <option key={key} value={key}>
            {label}
          </option>
        ))}
      </select>
    </div>
  )
}